import type { AxiosRequestConfig } from 'axios'
import type { RequestOptions } from '@mp/http-axios'
import { ZF_NO } from '@mp/constant'

import { createAxios } from './index'

function injectAppId(payload: unknown): Record<string, unknown> {
  const data = (payload && typeof payload === 'object' && !Array.isArray(payload))
    ? payload as Record<string, unknown>
    : {}

  return {
    ...data,
    appId: (typeof data.appId === 'string' && data.appId) ? data.appId : ZF_NO,
  }
}

/** sdpshop 网关接口统一补 appId */
function withAppId(options: AxiosRequestConfig): AxiosRequestConfig {
  const method = (options.method || 'GET').toUpperCase()
  const { data } = options

  if (typeof FormData !== 'undefined' && data instanceof FormData) {
    if (!data.get('appId'))
      data.append('appId', ZF_NO)
    return options
  }

  if (method === 'GET') {
    return {
      ...options,
      params: injectAppId(options.params),
    }
  }

  return {
    ...options,
    data: injectAppId(data),
  }
}

export const defHttp = createAxios({
  requestOptions: {
    apiUrl: window.location.origin,
    urlPrefix: '/mchgateway/sdpshop',
  },
})

export function request<T>(url: string, options: AxiosRequestConfig & { customOptions?: RequestOptions }): Promise<T> {
  const { customOptions } = options || {}
  return defHttp.request({ ...withAppId(options), url }, customOptions)
}
